module.exports = __webpack_public_path__ + "static/img/sucai.e6cc3990.png";